import Cookies from "js-cookie";
import { PulseLoader } from "react-spinners";
import { useMapProvider } from "../hooks/useMapProvider";
import { useTranslateText } from "../hooks/useTranslateText";
import { isRussianLanguageName } from "../utils/mapProvider";

function getThemeColor() {
  if (typeof document === "undefined") return "#FCC604";
  const fromCookie = Cookies.get("theme_color")?.trim();
  if (fromCookie) return fromCookie;
  const fromCss = getComputedStyle(document.documentElement)
    .getPropertyValue("--theme-color")
    .trim();
  return fromCss || "#FCC604";
}

export default function TypingIndicator({
  className = "",
}: {
  className?: string;
}) {
  const translate = useTranslateText();
  const { languageName } = useMapProvider();
  const translated = translate("Typing");
  const label =
    translated !== "Typing"
      ? translated
      : isRussianLanguageName(languageName)
        ? "Печатает"
        : "Typing";

  return (
    <div
      className={`inline-flex h-[14px] max-h-[14px] items-center gap-1 overflow-hidden text-themeColor ${className}`.trim()}
    >
      <span className="text-[12px] font-medium leading-none tracking-tight">
        {label}
      </span>
      <span className="inline-flex h-[10px] items-center leading-none">
        <PulseLoader
          speedMultiplier={0.85}
          color={getThemeColor()}
          size={3}
          margin={1}
        />
      </span>
    </div>
  );
}
